export const MADRID_VINOGRADA_TOUR_KEY = "od-madrida-do-vinograda";
export const MADRID_VINOGRADA_COVER = "/images/madrid-vinograda/1000149586.jpg";

export const MADRID_VINOGRADA_HR_DETAILED_INFO = `Od Madrida do vinograda: Fiesta San Lorenzo u Valladolidu, čarolija vinskih sela i vinograda Ribera del Duero do romantične Segovie

🗓 10.09. do 15.09.2026.
🗓 15.10. do 20.10.2026.

📍 PROGRAM PUTOVANJA
________________________________________
🛬 DAN 1 - Madrid
Dolazak u Madrid i transfer do smještaja u centru grada.
Nakon smještaja slijedi lagana šetnja:
• Puerta del Sol
• Plaza Mayor
• Gran Via
• La Latina
Večera u lokalnom restoranu uz tapas i vino - uvod u španjolsku gastronomiju gdje se hrana dijeli i uživa bez žurbe. Prijedlog za Flamenco večer uz tapas i vino sigurno vas neće ostaviti ravnodušnima.
🛏️ Noćenje u Madridu
________________________________________
🚐 DAN 2 - Madrid -> Valladolid
Doručak u obližnjoj churreriji, churrosi s toplom čokoladom budi sva osjetila. Nakon doručka ćemo se uputiti na vlak za Valladolid. Polazak prema Valladolidu (cca 1.30h vožnje).
Dolazak, smještaj u hotel i slobodno vrijeme, šetnja i upoznavanje sa gradom i bogatom poviješću Valladolida.
Sudjelovanje u Fiestas de San Lorenzo, najvećem godišnjem događaju grada.
🍽️ Gastronomija Valladolida (uvod)
Valladolid je jedno od gastronomskih središta provincije Castilla, poznat po:
• lechazo (mlada janjetina stara 25 dana hranjena samo majčinim mlijekom) koji se topi u ustima. Peče se u glinenoj posudi (horno de lena). Samo sa soli i vodom - bez začina
• vrhunskim vinima iz vrlo poznate vinske regije Ribera del Duero
• uz lechazo se tradicionalno pije crno vino iz Ribera del Duera
• tapas kulturi (grad je višestruki pobjednik tapas natjecanja)
🛏️ Noćenje u Valladolidu
________________________________________
🎉 DAN 3 - Valladolid (Fiesta + gastronomija)
Dan za obilazak znamenitosti Valladolida, katedrala, Plaza Mayor, crkva San Lorenza i mnoge druge znamenitosti. Nakon upoznavanja grada idealno se izgubiti u masi ljudi i uživati u festivalima, koncertima, uličnim zabavama i gastronomiji.
🛏️ Noćenje u Valladolidu
________________________________________
🍷 DAN 4 - Vinska ruta Ribera del Duero
Polazak u jutarnjim satima na vinsku turu kroz regiju Ribera del Duero.
📍 Obilazak sela:
• Valbuena de Duero
• Pesquera de Duero
• Curiel de Duero
• Penafiel
🏰 Penafiel
• impresivan dvorac koji dominira krajolikom
• jedan od simbola vinske regije
• muzej vina nije uključen u cijenu
🍇 Vinarije
Posjet 1-2 lokalne vinarije:
• degustacija vina (Tempranillo)
• upoznavanje tradicije proizvodnje
• u tom području se osjeti da ljudi žive vino, a priroda i krajolici ostavljaju bez daha
🍽️ Ručak:
👉 Restaurante Quintana
Tradicionalna kastiljska domaća kuhinja uz vrhunska vina.
Povratak u Valladolid.
Slobodno vrijeme za zadnju večer po uličnim fiestama Valladolida.
🛏️ Noćenje u Valladolidu
________________________________________
🏰 DAN 5 - Segovia
Polazak u jutarnjim satima sa vlakom prema Segoviji i razgled grada:
• rimski akvadukt (star gotovo 2000 godina)
• Alcazar dvorac koji je inspirirao Disney
• povijesna jezgra grada (UNESCO)
________________________________________
🍽️ COCHINILLO - simbol Segovije - gastronomija je za prste polizati
Cochinillo (pečena prasetina) je najpoznatije jelo Segovije:
• koristi se prase staro 2-3 tjedna
• hrani se isključivo mlijekom
• meso je izuzetno mekano, s hrskavom kožicom
👉 priprema:
• pečenje u peći na drva
• tradicionalno bez puno začina
👉 posebnost:
• u Segoviji se reže tanjurom umjesto nožem
(dokaz koliko je meso mekano)

"Ovo nije samo jelo - ovo je ritual koji se ovdje njeguje stoljećima."
________________________________________
Gastronomsko iskustvo uz lokalno vino i tradicionalnu kuhinju, te druženje i slobodno vrijeme.
🛏️ Noćenje u Segoviji
________________________________________
✈️ DAN 6 - Segovia -> Madrid (aerodrom)
Ranojutarnjim vlakom krećemo prema Madridu na aerodrom (cca 1h) i povratak za Zagreb.
________________________________________
✔️ CIJENA UKLJUČUJE:
• avionsku kartu Zagreb Madrid Zagreb - ručna prtljaga do 10kg
• 5 noćenja (Madrid 1, Valladolid 3, Segovia 1)
• prijevoz prema programu vlak Madrid Valladolid Segovia- Madrid
• organizaciju vinske ture i prijevoz obilaska španjolskih sela
• 1 degustaciju vina u odabranoj vinariji
• pratitelja putovanja na hrvatskom i španjolskom jeziku
________________________________________
❌ CIJENA NE UKLJUČUJE:
• degustacije u za drugu ili više vinarija
• ulaznice za atrakcije
• gradski prijevoz
• osobnu potrošnju
• prehrana
________________________________________
🌟 ISTAKNUTO
• Fiesta San Lorenzo 🎉
• lechazo - autentična kastiljska kuhinja 🍖
• Ribera del Duero vinska ruta 🍷
• sela: Valbuena, Pesquera, Curiel i Penafiel
• cochinillo - gastronomski simbol Segovije 🐖
• Segovia - UNESCO grad

💰 CIJENA PAKET ARANŽMANA
1.290,00 EUR po osobi
(da bi se putovanje ostvarilo potrebno je minimalno 10 osoba)

Uvjeti plaćanja
• Za potvrdu rezervacije potrebno je uplatiti akontaciju u iznosu od 40% ukupne cijene aranžmana po osobi na broj računa HR7523400093207336956. Uplata akontacije smatra se potvrdom rezervacije i prihvaćanjem ponude. Preostali iznos potrebno je uplatiti najkasnije 10 dana prije polaska na putovanje. U slučaju neplaćanja preostalog iznosa u navedenom roku, organizator zadržava pravo otkazivanja rezervacije. Sve navedeno će biti proslijeđeno svakom putniku u predugovornim informacijama.
• Rezervacije i informacije
• 📧 Email: info@linatravelina.eu
📞 Telefon: +385 91 214 4477

✨ TraveLina - putovanja koja se pamte!`;

export const MADRID_VINOGRADA_EN_DETAILED_INFO = `From Madrid to the Vineyards: Fiesta San Lorenzo in Valladolid, the magic of Ribera del Duero wine villages and vineyards, and romantic Segovia

🗓 10–15 September 2026
🗓 15–20 October 2026

📍 TRAVEL PROGRAMME
________________________________________
🛬 DAY 1 – Madrid
Arrival in Madrid and transfer to accommodation in the city centre.
After check-in, a gentle walk:
• Puerta del Sol
• Plaza Mayor
• Gran Vía
• La Latina
Dinner at a local restaurant with tapas and wine – an introduction to Spanish gastronomy where food is shared and enjoyed without rush. An optional flamenco evening with tapas and wine is sure to leave a lasting impression.
🛏️ Overnight in Madrid
________________________________________
🚐 DAY 2 – Madrid → Valladolid
Breakfast at a nearby churrería – churros with hot chocolate to awaken all the senses. After breakfast we take the train to Valladolid (approx. 1 h 30 min).
Arrival, hotel check-in and free time to walk and discover the city and its rich history.
Participation in the Fiestas de San Lorenzo, the city's biggest annual event.
🍽️ Valladolid gastronomy (introduction)
Valladolid is one of Castilla's gastronomic centres, known for:
• lechazo (25-day-old milk-fed lamb that melts in the mouth), roasted in a clay dish (horno de leña), with only salt and water – no spices
• outstanding wines from the famous Ribera del Duero region
• traditionally paired with lechazo: red wine from Ribera del Duero
• tapas culture (the city is a multiple winner of tapas competitions)
🛏️ Overnight in Valladolid
________________________________________
🎉 DAY 3 – Valladolid (Fiesta + gastronomy)
A day to visit Valladolid's sights: cathedral, Plaza Mayor, San Lorenzo church and many other landmarks. After exploring the city, lose yourself in the crowds and enjoy festivals, concerts, street celebrations and gastronomy.
🛏️ Overnight in Valladolid
________________________________________
🍷 DAY 4 – Ribera del Duero wine route
Early morning departure on a wine tour through the Ribera del Duero region.
📍 Villages visited:
• Valbuena de Duero
• Pesquera de Duero
• Curiel de Duero
• Peñafiel
🏰 Peñafiel
• impressive castle dominating the landscape
• one of the symbols of the wine region
• wine museum not included in the price
🍇 Wineries
Visit to 1–2 local wineries:
• wine tasting (Tempranillo)
• introduction to traditional production
• here you feel that people live for wine, and nature and landscapes take your breath away
🍽️ Lunch:
👉 Restaurante Quintana
Traditional Castilian home cooking with outstanding wines.
Return to Valladolid.
Free time for a final evening among Valladolid's street fiestas.
🛏️ Overnight in Valladolid
________________________________________
🏰 DAY 5 – Segovia
Early morning train to Segovia and city tour:
• Roman aqueduct (nearly 2,000 years old)
• Alcázar castle that inspired Disney
• historic old town (UNESCO)
________________________________________
🍽️ COCHINILLO – symbol of Segovia – gastronomy to savour
Cochinillo (roast suckling pig) is Segovia's most famous dish:
• piglet aged 2–3 weeks
• fed exclusively on milk
• exceptionally tender meat with crispy skin
👉 preparation:
• wood-fired oven roasting
• traditionally with few spices
👉 special feature:
• in Segovia it is cut with a plate instead of a knife
(proof of how tender the meat is)

"This is not just a dish – it is a ritual nurtured here for centuries."
________________________________________
Gastronomic experience with local wine and traditional cuisine, time together and free time.
🛏️ Overnight in Segovia
________________________________________
✈️ DAY 6 – Segovia → Madrid (airport)
Early morning train to Madrid airport (approx. 1 h) and return flight to Zagreb.
________________________________________
✔️ PRICE INCLUDES:
• return flight Zagreb–Madrid–Zagreb – hand luggage up to 10 kg
• 5 nights (Madrid 1, Valladolid 3, Segovia 1)
• transport per programme by train Madrid–Valladolid–Segovia–Madrid
• organisation of the wine tour and transport for village visits
• 1 wine tasting at a selected winery
• tour leader in Croatian and Spanish
________________________________________
❌ NOT INCLUDED:
• tastings at a second or additional wineries
• attraction entrance fees
• city transport
• personal expenses
• meals
________________________________________
🌟 HIGHLIGHTS
• Fiesta San Lorenzo 🎉
• lechazo – authentic Castilian cuisine 🍖
• Ribera del Duero wine route 🍷
• villages: Valbuena, Pesquera, Curiel and Peñafiel
• cochinillo – gastronomic symbol of Segovia 🐖
• Segovia – UNESCO city

💰 PACKAGE PRICE
€1,290.00 per person
(minimum 10 people required for the trip to take place)

Payment terms
• To confirm your booking, a deposit of 40% of the total package price per person is required to account HR7523400093207336956. The remaining balance is due at least 10 days before departure. If the balance is not paid within the stated period, the organiser reserves the right to cancel the booking. All details will be provided in pre-contract information.
• Bookings and information
• 📧 Email: info@linatravelina.eu
📞 Phone: +385 91 214 4477

✨ TraveLina – trips you'll remember!`;

export const MADRID_VINOGRADA_DE_DETAILED_INFO = `Von Madrid zu den Weinbergen: Fiesta San Lorenzo in Valladolid, die Magie der Weindörfer und Weinberge der Ribera del Duero bis zur romantischen Segovia

🗓 10.–15. September 2026
🗓 15.–20. Oktober 2026

📍 REISEPROGRAMM
________________________________________
🛬 TAG 1 – Madrid
Ankunft in Madrid und Transfer zur Unterkunft im Stadtzentrum.
Nach dem Check-in ein gemütlicher Spaziergang:
• Puerta del Sol
• Plaza Mayor
• Gran Vía
• La Latina
Abendessen in einem lokalen Restaurant mit Tapas und Wein – Einführung in die spanische Gastronomie, bei der man ohne Eile teilt und genießt. Optional: Flamenco-Abend mit Tapas und Wein.
🛏️ Übernachtung in Madrid
________________________________________
🚐 TAG 2 – Madrid → Valladolid
Frühstück in einer nahegelegenen Churrería – Churros mit heißer Schokolade. Anschließend Zug nach Valladolid (ca. 1 Std. 30 Min.).
Ankunft, Hotel-Check-in und freie Zeit zum Erkunden der Stadt und ihrer reichen Geschichte.
Teilnahme an den Fiestas de San Lorenzo, dem größten jährlichen Ereignis der Stadt.
🍽️ Gastronomie Valladolid (Einführung)
Valladolid ist eines der gastronomischen Zentren Kastiliens, bekannt für:
• Lechazo (25 Tage altes, nur mit Muttermilch gefüttertes Lamm, das auf der Zunge zergeht), im Lehmofen (horno de leña) mit nur Salz und Wasser
• hervorragende Weine aus der Ribera del Duero
• traditionell dazu Rotwein aus der Ribera del Duero
• Tapas-Kultur (mehrfacher Sieger bei Tapas-Wettbewerben)
🛏️ Übernachtung in Valladolid
________________________________________
🎉 TAG 3 – Valladolid (Fiesta + Gastronomie)
Tag für Sehenswürdigkeiten: Kathedrale, Plaza Mayor, Kirche San Lorenzo und vieles mehr. Danach in der Menge untergehen und Festivals, Konzerte, Straßenfeste und Gastronomie genießen.
🛏️ Übernachtung in Valladolid
________________________________________
🍷 TAG 4 – Weinroute Ribera del Duero
Frühmorgendliche Abfahrt auf eine Weintour durch die Ribera del Duero.
📍 Dörfer:
• Valbuena de Duero
• Pesquera de Duero
• Curiel de Duero
• Peñafiel
🏰 Peñafiel
• imposante Burg über der Landschaft
• Symbol der Weinregion
• Weinmuseum nicht im Preis enthalten
🍇 Weingüter
Besuch von 1–2 lokalen Weingütern:
• Weinverkostung (Tempranillo)
• traditionelle Produktion
• hier spürt man, dass die Menschen vom Wein leben – Natur und Landschaft nehmen den Atem
🍽️ Mittagessen:
👉 Restaurante Quintana
Traditionelle kastilische Hausküche mit Spitzenweinen.
Rückkehr nach Valladolid. Freie Zeit für den letzten Abend bei den Straßenfiestas.
🛏️ Übernachtung in Valladolid
________________________________________
🏰 TAG 5 – Segovia
Frühmorgendlicher Zug nach Segovia und Stadtrundgang:
• römisches Aquädukt (fast 2000 Jahre alt)
• Alcázar-Schloss, das Disney inspirierte
• historische Altstadt (UNESCO)
________________________________________
🍽️ COCHINILLO – Symbol Segovias
Cochinillo (Spanferkel) ist das berühmteste Gericht Segovias:
• Ferkel im Alter von 2–3 Wochen
• ausschließlich Milchnahrung
• extrem zartes Fleisch mit knuspriger Haut
👉 Zubereitung im Holzofen, traditionell mit wenig Gewürzen
👉 Besonderheit: in Segovia wird es mit dem Teller statt dem Messer geschnitten

„Das ist nicht nur ein Gericht – es ist ein seit Jahrhunderten gepflegtes Ritual.“
________________________________________
Gastronomisches Erlebnis mit lokalem Wein, Zeit zusammen und freier Abend.
🛏️ Übernachtung in Segovia
________________________________________
✈️ TAG 6 – Segovia → Madrid (Flughafen)
Frühmorgendlicher Zug zum Flughafen Madrid (ca. 1 Std.) und Rückflug nach Zagreb.
________________________________________
✔️ PREIS INKLUSIVE:
• Flug Zagreb–Madrid–Zagreb – Handgepäck bis 10 kg
• 5 Übernachtungen (Madrid 1, Valladolid 3, Segovia 1)
• Zugtransport Madrid–Valladolid–Segovia–Madrid laut Programm
• Organisation der Weintour und Transport zu den Dörfern
• 1 Weinverkostung in ausgewähltem Weingut
• Reiseleitung auf Kroatisch und Spanisch
________________________________________
❌ NICHT INKLUSIVE:
• weitere Verkostungen in anderen Weingütern
• Eintrittsgelder
• Stadtverkehr
• persönliche Ausgaben
• Verpflegung
________________________________________
🌟 HIGHLIGHTS
• Fiesta San Lorenzo 🎉
• Lechazo – authentische kastilische Küche 🍖
• Weinroute Ribera del Duero 🍷
• Dörfer Valbuena, Pesquera, Curiel, Peñafiel
• Cochinillo – gastronomisches Symbol Segovias 🐖
• Segovia – UNESCO-Stadt

💰 PAKETPREIS
1.290,00 EUR pro Person (mind. 10 Personen)

Zahlungsbedingungen: 40 % Anzahlung auf HR7523400093207336956, Rest 10 Tage vor Abreise.

📧 info@linatravelina.eu | 📞 +385 91 214 4477 | ✨ TraveLina`;

export const MADRID_VINOGRADA_ES_DETAILED_INFO = `De Madrid a los viñedos: Fiesta San Lorenzo en Valladolid, la magia de los pueblos y viñedos de Ribera del Duero y la romántica Segovia

🗓 10–15 septiembre 2026
🗓 15–20 octubre 2026

📍 PROGRAMA DEL VIAJE
________________________________________
🛬 DÍA 1 – Madrid
Llegada a Madrid y traslado al alojamiento en el centro.
Tras el check-in, paseo tranquilo:
• Puerta del Sol
• Plaza Mayor
• Gran Vía
• La Latina
Cena en restaurante local con tapas y vino – introducción a la gastronomía española para compartir sin prisas. Opcional: noche de flamenco con tapas y vino.
🛏️ Noche en Madrid
________________________________________
🚐 DÍA 2 – Madrid → Valladolid
Desayuno en churrería cercana – churros con chocolate caliente. Tren a Valladolid (aprox. 1 h 30 min).
Llegada, hotel y tiempo libre para conocer la ciudad y su rica historia.
Participación en las Fiestas de San Lorenzo, el mayor evento anual de la ciudad.
🍽️ Gastronomía de Valladolid (introducción)
Valladolid es uno de los centros gastronómicos de Castilla, conocido por:
• lechazo (cordero lechal de 25 días alimentado solo con leche materna), asado en horno de leña con sal y agua
• vinos excelentes de Ribera del Duero
• tradicionalmente acompañado de vino tinto de Ribera del Duero
• cultura de tapas (múltiple ganador de concursos de tapas)
🛏️ Noche en Valladolid
________________________________________
🎉 DÍA 3 – Valladolid (Fiesta + gastronomía)
Día para visitar la catedral, Plaza Mayor, iglesia de San Lorenzo y otras joyas. Después, perderse entre la gente y disfrutar de festivales, conciertos, fiestas callejeras y gastronomía.
🛏️ Noche en Valladolid
________________________________________
🍷 DÍA 4 – Ruta del vino Ribera del Duero
Salida temprano en ruta enológica por la Ribera del Duero.
📍 Pueblos:
• Valbuena de Duero
• Pesquera de Duero
• Curiel de Duero
• Peñafiel
🏰 Peñafiel – castillo imponente, símbolo de la región (museo del vino no incluido)
🍇 Bodegas – visita a 1–2 bodegas locales con cata de Tempranillo y tradición vitivinícola
🍽️ Almuerzo en Restaurante Quintana – cocina castellana tradicional con grandes vinos.
Regreso a Valladolid. Tarde libre en las fiestas callejeras.
🛏️ Noche en Valladolid
________________________________________
🏰 DÍA 5 – Segovia
Tren matutino a Segovia: acueducto romano (casi 2000 años), alcázar que inspiró a Disney, casco histórico UNESCO.
________________________________________
🍽️ COCHINILLO – símbolo de Segovia
Cochinillo asado (cerdo lechal de 2–3 semanas, solo leche): carne tierna y piel crujiente, horno de leña, pocos condimentos. En Segovia se corta con plato, no con cuchillo – prueba de su ternura.

«No es solo un plato – es un ritual cultivado durante siglos.»
________________________________________
Experiencia gastronómica con vino local y tiempo libre.
🛏️ Noche en Segovia
________________________________________
✈️ DÍA 6 – Segovia → Madrid (aeropuerto)
Tren temprano al aeropuerto de Madrid (aprox. 1 h) y vuelo de regreso a Zagreb.
________________________________________
✔️ INCLUYE:
• vuelo Zagreb–Madrid–Zagreb – equipaje de mano hasta 10 kg
• 5 noches (Madrid 1, Valladolid 3, Segovia 1)
• trenes Madrid–Valladolid–Segovia–Madrid según programa
• organización de la ruta del vino y transporte a los pueblos
• 1 cata de vino en bodega seleccionada
• guía en croata y español
________________________________________
❌ NO INCLUYE:
• catas adicionales en otras bodegas
• entradas a atracciones
• transporte urbano
• gastos personales
• comidas
________________________________________
🌟 DESTACADOS
• Fiesta San Lorenzo 🎉 • lechazo 🍖 • Ribera del Duero 🍷
• pueblos Valbuena, Pesquera, Curiel, Peñafiel
• cochinillo 🐖 • Segovia UNESCO

💰 PRECIO DEL PAQUETE: 1.290,00 EUR por persona (mín. 10 personas)

Condiciones de pago: 40 % depósito en HR7523400093207336956; resto 10 días antes de la salida.

📧 info@linatravelina.eu | 📞 +385 91 214 4477 | ✨ TraveLina`;

const MADRID_VINOGRADA_DETAILED_INFO = {
  hr: MADRID_VINOGRADA_HR_DETAILED_INFO,
  en: MADRID_VINOGRADA_EN_DETAILED_INFO,
  de: MADRID_VINOGRADA_DE_DETAILED_INFO,
  es: MADRID_VINOGRADA_ES_DETAILED_INFO,
};

export function mergeMadridVinogradaIfMissing(tours, galleryPaths = []) {
  if (!Array.isArray(tours) || tours.length === 0) return tours;

  const normalized = tours.map((t) =>
    t?.key === "madrid-vinograda" ? { ...t, key: MADRID_VINOGRADA_TOUR_KEY } : t
  );

  const existing = normalized.find((t) => t?.key === MADRID_VINOGRADA_TOUR_KEY);
  if (existing) {
    return normalized.map((tour) => {
      if (tour?.key !== MADRID_VINOGRADA_TOUR_KEY) return tour;
      return {
        ...tour,
        detailedInfo: { ...(tour.detailedInfo || {}), ...MADRID_VINOGRADA_DETAILED_INFO },
        image: tour.image || MADRID_VINOGRADA_COVER,
        gallery:
          Array.isArray(tour.gallery) && tour.gallery.length > 0
            ? tour.gallery
            : galleryPaths.length > 0
              ? galleryPaths
              : [MADRID_VINOGRADA_COVER],
      };
    });
  }

  const nextId = Math.max(0, ...normalized.map((t) => Number(t?.id) || 0)) + 1;
  const newTour = {
    id: nextId,
    key: MADRID_VINOGRADA_TOUR_KEY,
    category: "city",
    days: 6,
    nights: 5,
    country: "Spain",
    date: "2026-09-10",
    price: 1290,
    tag: "New",
    image: MADRID_VINOGRADA_COVER,
    blogText: { hr: "", en: "", de: "", es: "" },
    gallery: galleryPaths.length > 0 ? [...galleryPaths] : [MADRID_VINOGRADA_COVER],
    detailedInfo: MADRID_VINOGRADA_DETAILED_INFO,
  };
  return [...normalized, newTour];
}
